<template>
  <Dropdown
    :key="item.pathName"
    placement="right-start"
    transfer
    transfer-class-name="topMenuTransfer"
    v-if="item.children && item.children.length> 0"
  >
    <DropdownItem>
      <span>{{item.menuName}}</span>
      <Icon type="ios-arrow-forward"></Icon>
    </DropdownItem>
    <DropdownMenu slot="list" v-if="item.children && item.children.length > 0">
      <template v-for="child in item.children">
        <subHorizontalMenu :item="child" :key="'menu-sub-'+child.menuCode"></subHorizontalMenu>
      </template>
    </DropdownMenu>
  </Dropdown>
  <DropdownItem :key="item.pathName" :name="item.pathName" v-else>
    <span>{{item.menuName}}</span>
    <Badge :count="$store.getters.inboxCount" v-if="item.menuCode == 'inbox'"></Badge>
    <Badge
      :count="$store.getters.todoCount"
      v-if="item.menuCode == 'workflow.config.myaffairs.todo'"
    ></Badge>
  </DropdownItem>
</template>
<script>
export default {
  name: 'subHorizontalMenu',
  props: {
    item: {
      type: Object,
      default: () => { }
    },
  }
}
</script>